import { render, staticRenderFns } from "./dataForm.vue?vue&type=template&id=4c9f4a3d&"
import script from "./dataForm.vue?vue&type=script&lang=js&"
export * from "./dataForm.vue?vue&type=script&lang=js&"
import style0 from "./dataForm.vue?vue&type=style&index=0&id=4c9f4a3d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports